import React from "react";
import Button from "../../_components/button/Button";
import SlideOver from "../../_components/slide_over/SlideOver";
const HdmiBoard = () => {
  const [showSlideOver, setSlideOver] = React.useState(false);

  const handleClick = () => {
    setSlideOver(true);
  };

  const Content = () => {
    return (
      <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
        <dl className="space-y-8 px-4 sm:px-6 sm:space-y-6">
          <div>
            <h5 className="text-md lg:text-xl font-bold text-gray-700 mb-2">
              Enhanced Audio Return Channel (e-ARC)
            </h5>

            <p className="text-sm lg:text-md">
              e-ARC simplifies connectivity, provides greater ease of use, and
              supports the most advanced audio formats and highest audio
              quality. It ensures full compatibility between audio devices and
              upcoming HDMI 2.1 products.
            </p>
          </div>

          <div>
            <h5 className="text-md lg:text-xl font-bold text-gray-700 mb-2">
              Dynamic HDR
            </h5>
            <p className="text-sm lg:text-md">
              {" "}
              Dynamic HDR support ensures every moment of a video is displayed
              at its ideal values for depth, detail, brightness, contrast and
              wider color gamuts—on a scene-by-scene or even a frame-by-frame
              basis.
            </p>
          </div>

          <div>
            <h5 className="text-md lg:text-xl font-bold text-gray-700 mb-2">
              Enhanced Gaming Features
            </h5>
            <p className="text-sm lg:text-md">
              Enhanced gaming features ensure an added level of smooth and
              seamless motion and transitions for gaming, movies and video
              Variable Refresh Rate (VRR) reduces or eliminates lag, stutter and
              frame tearing for more fluid and better detailed gameplay. Auto
              Low Latency Mode (ALLM) allows the ideal latency setting to
              automatically be set allowing for smooth, lag-free and
              uninterrupted viewing and interactivity.
            </p>
          </div>
        </dl>
      </div>
    );
  };

  return (
    <section className="z-50 relative " id="hdmi_board">
      <SlideOver
        open={showSlideOver}
        setOpen={setSlideOver}
        title={"Advanced 8K HDMI Platform with e-ARC Support"}
        content={<Content />}
      />
      <div className="bg-black  py-12 px-6 md:py-20 ">
        <div className="max-w-7xl mx-auto  text-white  md:text-gray-900">
          <h4 className="relative text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug z-50">
            Advanced 8K HDMI Platform <br /> with e-ARC Support
          </h4>
          <div class="flex flex-wrap">
            <div className="w-full lg:w-2/5 z-10">
              <p className="text-white mb-16 text-xl font-light lg:mt-10 lg:text-left text-center">
                Feel the power of every frame with the AVM 90 and its advanced
                8K HDMI 2.1 Platform with HDCP 2.3. Showcasing 7 dedicated 8K
                inputs that support 8K/60Hz or 4K/120Hz pass-through and 3
                dedicated outputs with Enhanced Audio Return Channel, you can
                enjoy 8K quality video from all of your 8K source devices in
                amazing clarity. Also featuring the latest HDMI technology and
                specification, the AVM 90 allows you to take your home
                entertainment to the next level with HDR10+, ALLM and VRR. The
                possibilities are limitless; unlock the true potential of your
                media with the industry’s most flexible and feature-rich HDMI
                platform.
              </p>
              <Button name="Learn More" handleClick={handleClick} />
            </div>
            <div className="order-first lg:order-last w-full lg:w-3/5 ">
              <img
                className="scale-100 lg:scale-110"
                src="https://cdn.pmlsound.com/anthem/avm90/images/hdmi-board-avm-90.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HdmiBoard;
